// Full-page navigation (NOT react-router) — used to hand the browser off to a
// Stripe-hosted Checkout / Billing Portal URL. Isolated in one tiny module so
// tests can mock the redirect instead of tripping jsdom's "navigation not
// implemented" on window.location.
export function redirectTo(url: string): void {
  window.location.assign(url);
}
